// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-1VOOC";
var _4 = "left-293yX";
var _5 = "right-3eppc";
var _6 = "withTooltip-3tmNd";
var _7 = "optionIcon-bD5zH";
var _8 = "paymentIcon-1lkVd";
var _9 = "title-AurNb";
var _a = "param-w3lJa";
var _b = "free-3vdei";
var _c = "pay-2ridW";
var _d = "notAvailable-2bgVd";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "left", _5 as "right", _6 as "withTooltip", _7 as "optionIcon", _8 as "paymentIcon", _9 as "title", _a as "param", _b as "free", _c as "pay", _d as "notAvailable" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "left": _4, "right": _5, "withTooltip": _6, "optionIcon": _7, "paymentIcon": _8, "title": _9, "param": _a, "free": _b, "pay": _c, "notAvailable": _d }
